import { JioTranslatePlugin, UiMiddleware } from '@jiotranslate/core-beta';
import { isSSR } from './tools/isSSR';
import { InContextUi } from './ui/InContextUi';

export const ContextUi = (): JioTranslatePlugin => (jiotranslate, tools) => {
  let ui: UiMiddleware | undefined = undefined;

  if (!isSSR()) {
    ui = (props) => InContextUi(props);
  }
  tools.setUi(ui);
  return jiotranslate;
};
